export default [{
    path: 'campaigns',
    name: 'campaign-dashboard',
    component: () => import ('source/pages/root/JobApplicationPageGroup.vue'),
    meta: {
        title: 'Dashboard - HQZen',
        canDisplayGlobalModals: true
    },
    children: [
        {
            path: 'employments/add-invited/:booking_id/:campaign_id',
            name: 'employer-invite-applicants',
            component: () => import ('source/pages/applicants/EmployerInviteApplicants.vue'),
            props: true,
            meta: {
                title: 'HQZen',
                canDisplayGlobalModals: false
            },
            children: [{
                path: ':applicant_id',
                name: 'applicant-info-modal-invite-more-applicants',
                component: () => import ('source/components/bookings/CardApplicantInfoModal.vue'),
                props: true,
                meta: {
                    title: 'HQZen',
                    canDisplayGlobalModals: false
                }
            }]
        }, {
            path: 'send-job-offer',
            name: 'send-job-offer',
            component: () => import ('source/pages/employers/applicants/SendJobOfferPage.vue'),
            props: true,
            meta: {
                title: 'Send Job Offer - HQZen',
                canDisplayGlobalModals: true
            }
        }, {
            path: 'applicants/:applicant_id',
            name: 'employer-dashboard-applicant-profile',
            component: () => import ('source/pages/employers/applicants/ApplicantInformationSection.vue'),
            props: true,
            meta: {
                title: 'Applicants - HQZen',
                canDisplayGlobalModals: true
            },
            children: [{
                path: 'info/',
                name: 'employer-dashboard-applicant-info-modal',
                component: () => import ('source/components/bookings/CardApplicantInfoModal.vue'),
                props: true,
                meta: {
                    title: 'HQZen',
                    canDisplayGlobalModals: false
                },
            }, {
                path: 'job-offers/:job_offer_id/offer-details/',
                name: 'applicant-profile-job-offer-details-modal',
                component: () => import ('source/components/employers/applicants/JobOfferDetailsModal.vue'),
                props: true,
                meta: {
                    title: 'HQZen',
                    canDisplayGlobalModals: false
                },
            }, {
                path: 'job-offers/:job_offer_id/cancel-job-offer',
                name: 'applicant-cancel-job-offer',
                component: () => import ('source/components/employers/job-offers/CancelJobOfferModal.vue'),
                props: true,
                meta: {
                    title: 'Cancel Job Offer - HQZen',
                    canDisplayGlobalModals: false
                },
            }, {
                path: 'job-offers/:job_offer_id/discussion',
                name: 'applicant-job-offer-discussion',
                component: () => import ('source/components/employers/job-offers/JobOfferNegotiationsModal.vue'),
                props: true,
                meta: {
                    title: 'Job Offers Negotiation - HQZen',
                    section: 'applicant',
                    canDisplayGlobalModals: false
                },
            }, {
                path: 'job_offers/:job_offer_id/:job_offer_status/',
                name: 'applicant-job-offer-sent-modal',
                component: () => import ('source/components/employers/job-offers/JobOfferSentModal.vue'),
                props: true,
                meta: {
                    title: 'Job Offer - HQZen',
                    canDisplayGlobalModals: false
                },
            }, {
                path: 'recordings/:recording_id/video/',
                name: 'applicant-interview-video-modal',
                component: () => import ('source/components/employers/ApplicantInterviewModal.vue'),
                props: true,
                meta: {
                    title: 'HQZen',
                    canDisplayGlobalModals: false
                }
            }]
        }, {
            path: 'job-postings/',
            name: 'campaign-job-postings',
            component: () => import ('source/pages/employers/applicants/JobPostingSection.vue'),
            props: true,
            meta: {
                title: 'Job Postings - HQZen',
                canDisplayGlobalModals: true,
                isInternal: true
            },
            children: [{
                path: ':jobPostingPk',
                name: 'job-posting-modal',
                component: () => import ('source/components/employers/job-postings/popups/JobPostingModal.vue'),
                props: true,
                meta: {
                    title: 'Job Postings - HQZen',
                    canDisplayGlobalModals: true,
                    isInternal: true
                }
            }]
        }]
}];
